/**
 * Blobs decorativos — manchas de cor pasteis pra background de seções.
 * Usado absoluto/fixed nos cantos pra dar profundidade sem ruído.
 */

interface BlobProps {
  className?: string;
  color?: "violet" | "pink" | "mint" | "yellow" | "coral" | "sky";
}

const COLOR_MAP = {
  violet: "hsl(255 78% 62%)",
  pink: "hsl(340 85% 70%)",
  mint: "hsl(160 60% 58%)",
  yellow: "hsl(45 95% 65%)",
  coral: "hsl(15 90% 68%)",
  sky: "hsl(200 90% 64%)",
} as const;

export function Blob({ className, color = "violet" }: BlobProps) {
  return (
    <svg
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
    >
      <path
        d="M 50 30 Q 110 10 150 50 Q 190 90 170 140 Q 150 190 90 180 Q 30 170 20 110 Q 10 50 50 30 Z"
        fill={COLOR_MAP[color]}
      />
    </svg>
  );
}

/** Forma "estrela soft" — quatro pontas arredondadas. */
export function SoftStar({ className, color = "violet" }: BlobProps) {
  return (
    <svg viewBox="0 0 100 100" className={className} aria-hidden>
      <path
        d="M 50 5 Q 60 35 95 50 Q 60 65 50 95 Q 40 65 5 50 Q 40 35 50 5 Z"
        fill={COLOR_MAP[color]}
      />
    </svg>
  );
}

/** Squircle (super-ellipse) colorido. */
export function Squircle({ className, color = "violet" }: BlobProps) {
  return (
    <svg viewBox="0 0 100 100" className={className} aria-hidden>
      <path
        d="M 0 50 C 0 5 5 0 50 0 C 95 0 100 5 100 50 C 100 95 95 100 50 100 C 5 100 0 95 0 50 Z"
        fill={COLOR_MAP[color]}
      />
    </svg>
  );
}
